import React, { useEffect, useRef } from 'react';

declare global {
  interface Window {
    createMyWidget?: (containerId: string, options: Record<string, any>) => void;
  }
}

interface PumpfunChartProps {
  tokenAddress: string;
}

const PRICE_CHART_ID = 'price-chart-widget-container';

const PumpfunChart: React.FC<PumpfunChartProps> = ({ tokenAddress }) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const loadWidget = () => {
      if (typeof window.createMyWidget === 'function') {
        window.createMyWidget(PRICE_CHART_ID, {
          autoSize: true,
          chainId: 'solana',
          tokenAddress,
          showHoldersChart: false,
          defaultInterval: '1',
          timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone ?? 'Etc/UTC',
          theme: 'moralis',
          locale: 'en',
          backgroundColor: '#111111',
          gridColor: '#2b2b2b',
          textColor: '#fff',
          candleUpColor: '#4CE666',
          candleDownColor: '#E64C4C',
          hideLeftToolbar: true,
          hideTopToolbar: false,
          hideBottomToolbar: true
        });
      } else {
        console.error('createMyWidget function is not defined.');
      }
    };

    if (!document.getElementById('moralis-chart-widget')) {
      const script = document.createElement('script');
      script.id = 'moralis-chart-widget';
      script.src = 'https://moralis.com/static/embed/chart.js';
      script.type = 'text/javascript';
      script.async = true;
      script.onload = loadWidget;
      script.onerror = () => {
        console.error('Failed to load the chart widget script.');
      };
      document.body.appendChild(script);
    } else {
      loadWidget();
    }
  }, [tokenAddress]);

  return (
    <div style={{ width: '100%', height: '100%' }}>
      <div
        id={PRICE_CHART_ID}
        ref={containerRef}
        style={{ width: '100%', height: '100%' }}
      />
    </div>
  );
};

export default PumpfunChart;